<div class="project-selector">
    <ui-spinner size="small" [style.visibility]="!(areProjectsLoaded$ | async) || (isProjectDataLoading$ | async) ? 'visible' : 'hidden'" />
    @if (currentProjectLogoUrl$ | async; as logoUrl) {
        <img class="project-picture" [src]="logoUrl" />
    }
    @if (currentProjectId$ | async; as currentProjectId) {
        <div class="project-selector-toggle" [class.disabled]="isProjectDataLoading$ | async" (click)="openModal()">
            @if (!(currentProjectLogoUrl$ | async)) {
                <span class="small-margin-right">{{ (currentProjectId | project)?.name }}</span>
            }
            <ui-icon name="dropdown-menu" color="primary" size="small" />
        </div>
    }
    @if ((hasNoProjects$ | async) && !(currentProjectId$ | async)) {
        <div>
            {{ 'APP.NO_PROJECT' | translate }}
        </div>
    }
</div>
